import { setStudySlideVisibility } from 'api/study';
import { Study } from 'interfaces/study';

export const saveDismissedCaseOrganizationSlideIds = ({
  study,
  slideId,
  isHidden,
}: {
  study: Study;
  slideId: string;
  isHidden: boolean;
}) =>
  setStudySlideVisibility({
    studyId: study.id,
    labId: study.labId,
    slideId,
    isHidden,
  });
